/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Page_OverlineInputs */

const en_mk_cmp_page_overline = /** @type {(inputs: Mk_Cmp_Page_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vs. Multica`)
};

const id_mk_cmp_page_overline = /** @type {(inputs: Mk_Cmp_Page_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vs Multica`)
};

/**
* | output |
* | --- |
* | "Vs. Multica" |
*
* @param {Mk_Cmp_Page_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_page_overline = /** @type {((inputs?: Mk_Cmp_Page_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Page_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_page_overline(inputs)
	return en_mk_cmp_page_overline(inputs)
});